import React from "react";

const SOCIALS = [
  {
    name: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61583257367995",
    icon: (
      <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24">
        <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
      </svg>
    ),
  },
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/company/101708551",
    icon: (
      <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24">
        <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" />
        <circle cx="4" cy="4" r="2" />
      </svg>
    ),
  },
  {
    name: "Instagram",
    href: "https://www.instagram.com/nosh_infotech/",
    icon: (
      <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
        <rect x="2" y="2" width="20" height="20" rx="5" />
        <circle cx="12" cy="12" r="4" />
        <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
      </svg>
    ),
  },
];

const PhoneIcon = () => (
  <svg width="13" height="13" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 8.81 19.79 19.79 0 01.01 2.18 2 2 0 012 .01h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
  </svg>
);

export default function Footer() {
  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        @keyframes ftFadeUp {
          from { opacity: 0; transform: translateY(20px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .ft-animate   { animation: ftFadeUp 0.6s ease forwards; }
        .ft-animate-3 { animation: ftFadeUp 0.6s ease 0.3s forwards; opacity: 0; }
        .ft-soc:hover { background: #1e293b; color: white; border-color: #1e293b; }
      `}</style>

      <div
        style={{
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          background: "#7b9fd4",
          padding: "0 12px 32px",
        }}
      >
        <div
          className="relative overflow-hidden"
          style={{
            background:
              "linear-gradient(170deg,#f0f4fc 0%,#d8e4f5 35%,#b8cff0 65%,#90aee0 100%)",
          }}
        >
          {/* Dot grid */}
          <div
            className="absolute inset-0 pointer-events-none"
            style={{
              backgroundImage:
                "radial-gradient(circle,rgba(80,110,180,0.15) 1px,transparent 1px)",
              backgroundSize: "26px 26px",
            }}
          />

          {/* ── Main content ── */}
          <div className="relative z-10 px-5 sm:px-10 lg:px-16 pt-8 pb-6">

            {/* ── Top row: Logo left, Socials right ── */}
            <div className="ft-animate flex items-center justify-between mb-6">
              {/* Logo */}
              {/* ── Bottom row: Contact info ── */}
            <div className="ft-animate flex flex-col gap-3">
              {/* Email */}
              <a
                href="mailto:info@noshinfotech.com"
                className="text-slate-800 font-semibold text-sm hover:text-blue-700 transition-colors"
              >
                info@noshinfotech.com
              </a>

              {/* Address */}
              <div className="flex items-start gap-2 text-slate-600 text-xs leading-relaxed">
                <svg
                  width="14" height="14" fill="none" stroke="currentColor"
                  strokeWidth="1.8" viewBox="0 0 24 24"
                  className="flex-shrink-0 mt-0.5"
                >
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" />
                  <circle cx="12" cy="9" r="2.5" />
                </svg>
                <span>
                  Near Surya Hospital, Pala Ram Market,<br />
                  Siwani 127044, Haryana, India
                </span>
              </div>

              {/* Phones */}
              <div className="flex flex-col gap-1.5">
                {["+91-92531-74295", "+91-85710-64055"].map((num) => (
                  <a
                    key={num}
                    href={`tel:${num.replace(/-/g, "")}`}
                    className="flex items-center gap-2 text-slate-600 hover:text-blue-700 transition-colors text-xs"
                  >
                    <PhoneIcon />
                    {num}
                  </a>
                ))}
              </div>
            </div>

              {/* Social icons — always top right */}
              <div className="flex flex-col items-end gap-2">
                <span className="text-[10px] font-bold text-slate-500 uppercase tracking-widest">
                  Follow Us
                </span>
                <div className="flex items-center gap-2">
                  {SOCIALS.map((s) => (
                    <a
                      key={s.name}
                      href={s.href}
                      target="_blank"
                      rel="noreferrer"
                      aria-label={s.name}
                      className="ft-soc w-8 h-8 sm:w-9 sm:h-9 rounded-full border border-slate-400/40 flex items-center justify-center text-slate-700 transition-all duration-200"
                    >
                      {s.icon}
                    </a>
                  ))}
                </div>
              </div>
            </div>

           
          </div>

          {/* ── Bottom bar ── */}
          <div className="ft-animate-3 relative z-10 px-5 sm:px-10 lg:px-16 py-3 border-t border-slate-400/20 flex items-center justify-center">
            <span className="text-xs text-slate-500 text-center">
              © 2026 Nosh Infotech. All Rights Reserved
            </span>
          </div>

          {/* ── Watermark ── */}
          <div className="relative z-0 select-none overflow-hidden" style={{ height: "100px" }}>
            <p
              className="absolute bottom-0 left-1/2 whitespace-nowrap font-black leading-none pointer-events-none"
              style={{
                transform: "translateX(-50%)",
                fontSize: "clamp(50px,10vw,130px)",
                color: "rgba(255,255,255,0.6)",
                letterSpacing: "-0.03em",
              }}
            >
              Nosh Infotech
            </p>
          </div>
        </div>
      </div>
    </>
  );
}